import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const ConsentApproval = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getConsentApproval(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query = JSON.stringify(values);

      let res = await fetch(
        `${config.host}/cdr-panel/consentApproval/consent-Approval?offset=${values?.offset}&limit=${values?.limit}&type=${values?.type}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function search(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/consentApproval/search?search=${values?.search}&offset=${values?.offset}&limit=${values?.limit}&type=${values?.type}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function exportAPI(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      };
      values = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/consentApproval/export?query=${values}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function updateConsent(values) {
    try {
      const obj = {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      };

      let res = await fetch(
        `${config.host}/cdr-panel/consentApproval/update`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function upload(values) {
    try {
      const obj = {
        method: "POST",
        credentials: "include",
        body: values,
      };
      let res = await fetch(
        `${config.host}/cdr-panel/consentApproval/upload`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getReasonDescription() {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/consentApproval/reason-description`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  return {
    getConsentApproval,
    updateConsent,
    search,
    upload,
    getReasonDescription,
    exportAPI,
  };
};
export default ConsentApproval;
